export default __webpack_public_path__ + "static/media/singidunum.2f67c7a2.png";